export default __webpack_public_path__ + "static/media/bubble.ad575755.png";